export default __webpack_public_path__ + "static/media/coolerdoor.652430c8.png";